<template>
  <div class="order-service" :class="{top_cont: top_cont}">
      <transition name="burger-fade">
      <div class="text-wrapper" v-if="!openServices">
          <svg xmlns="http://www.w3.org/2000/svg" width="25.835" height="24" viewBox="0 0 25.835 24">
  <g id="motorcycle" transform="translate(0 -15.088)">
    <path id="Path_3879" data-name="Path 3879" d="M25.169,123.806a2.555,2.555,0,0,0-.069-1.163c-.755-2.72-3.014-8.288-4.892-10.582a1.364,1.364,0,0,0-1.992,0,1.4,1.4,0,0,0-.405.867.986.986,0,0,0-.541-.257s-4.762-.593-4.819-.586H10.285a.807.807,0,0,0-.912.912v6.951H7.784v-7.455a.67.67,0,0,0-.669-.669H.669a.67.67,0,0,0-.669.669s0,10.468,0,11.145a1.408,1.408,0,0,0,1.408,1.408H2.792a3.806,3.806,0,1,0,7.391,0h4.259v.933a1.339,1.339,0,0,0,1.338,1.338h.026a1.328,1.328,0,0,0,1.327-1.341l-.009-.93h1.21a3.806,3.806,0,1,0,6.835-1.241Zm-3.139.711a1.436,1.436,0,1,1-1.437,1.436A1.438,1.438,0,0,1,22.029,124.518ZM7.924,125.954a1.436,1.436,0,1,1-1.436-1.436A1.438,1.438,0,0,1,7.924,125.954Zm9.149-5.8a1.353,1.353,0,0,0-1.348-1.335H13.5v-4.546l1.088.134a.905.905,0,0,0,.884.712h3.81l.3,2.461-2.5,3.269Z" transform="translate(0 -90.671)" fill="#044b30"/>
    <path id="Path_3880" data-name="Path 3880" d="M141.3,20.439a2.676,2.676,0,0,0,2.619-3.223l.587-.012a1.056,1.056,0,0,0,.877-.566l.2-.414a.549.549,0,0,0-.518-.818l-2.487.006a2.675,2.675,0,1,0-1.274,5.028Z" transform="translate(-130.193)" fill="#044b30"/>
  </g>
</svg>

          <span class="f-16 bold-italic w__change" @click="showOrderServices">{{$fn.tr('გამოძახების სერვისები')}}</span>
      </div>
      </transition>
        <transition name="burger-fade">
      <div class="services-list" v-if="openServices">
        <a target="_blank" :href="service.link" class="service-circle" v-for="(service, index) in services" :key="index">
        <div v-html="service.svg"></div>
     
      </a>
         <div class="x-btn" @click="showOrderServices">
            <svg xmlns="http://www.w3.org/2000/svg" width="17.392" height="18.542" viewBox="0 0 17.392 18.542">
  <g id="Group_2163" data-name="Group 2163" transform="matrix(0.755, 0.656, -0.656, 0.755, -272.385, -1396.472)">
    <path id="Path_219" data-name="Path 219" d="M.877,3.846c3.717.218,7.339-.737,11.042-.732,2.265,0,4.743.547,6.935-.351a1.63,1.63,0,0,0,1.168-1.625l-.005-.117C19.975.09,18.787.086,17.973.651c-2,.607-4.3-.069-6.328.023C8.384.824,5.171,1.594,1.89,1.4.761,1.335-1.035,3.733.877,3.846Z" transform="matrix(-0.998, -0.07, 0.07, -0.998, 1144.242, 879.279)" fill="#044b30" stroke="#044b30" stroke-width="0.5"/>
    <path id="Path_3800" data-name="Path 3800" d="M.824,4.173c3.706.1,7.344-.974,11.041-1.087,2.261-.069,4.723.4,6.932-.574A1.746,1.746,0,0,0,20,.845l0-.117c-.021-.931-1.207-.9-2.033-.3-2.01.673-4.294.069-6.319.226C8.387.9,5.161,1.779,1.89,1.69.764,1.66-1.082,4.121.824,4.173Z" transform="translate(1136.473 866.523) rotate(90)" fill="#044b30" stroke="#044b30" stroke-width="0.5"/>
  </g>
</svg>

        </div>
        
      </div>
     </transition>
  </div>
</template>

<script>
export default {
  props: ['top_cont'],
    data(){
        return{
            openServices: false,
          
        }
    },
    computed: {
      services(){
        return this.$store.state.main.indx.terms.order_services;
      }
    },
    methods: {
        showOrderServices(){
            this.openServices = !this.openServices;
        }
    }
}
</script>

<style lang="scss" scoped>
.order-service{
    margin-top: 13px;
    position: relative;
    
    overflow: visible;
    min-width: 400px;
    height: 50px;

  

    
}
.text-wrapper{
    display: flex;
    align-items: center;
      position: relative;
   
    span{
        cursor: pointer;
        text-decoration: underline;
        color: #044B30;
        text-align: center;
    }
    svg{
        margin-right: 13.2px;
    }
}
.service-circle{
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
    border-radius: 17px;
    height: 40px;
    width: 40px;
}
.services-list{
    position: absolute;
    display: flex;
    align-items: center;
    top: 0;
    left: 0;
    height: 50px;
    
  
  
    .x-btn{
        width: fit-content;
        height:fit-content;
        cursor: pointer;
        transition: .4s;
        will-change: transform;
          @media (min-width: 1024px){
            &:hover{
                transform: scale(1.2) rotate(-2deg);
            }
        }
    }
    .service-circle{
        margin-right: 21px;
        transition: .4s;
        will-change: transform;
        background-color:white;
        &:last-child{
            margin-right: 10px;
        }
        @media (min-width: 1024px){
            &:hover{
                transform: scale(1.2) rotate(-2deg);
            }
        }
    }
}

.order-service.top_cont{
  height: 41px;
  min-width: 100px;
  .services-list{
    left: 50%;
    transform: translateX(-50%);
  }
  .text-wrapper{
    span{
      font-size: 21px;
      line-height: 28px;
      margin-left: 0;
       @media (max-width: 413px) {
      font-size: 16px;
      line-height: 18px;

       }
    }
  }
}
</style>

<style lang="scss">
// .from-bottom-enter-active,
// .from-bottom-leave-active {
 
//   transition: all .7s;
// }
// .from-bottom-enter{
//    transform: translateY(0);
//    opacity: 0;
// }
// .from-bottom-leave-to {
//   transform: translateY(-100%);
//    transition: all .7s;
//   opacity: 1;
// }



// .from-bottom2-enter-active,
// .from-bottom2-leave-active {
//   transform: translateY(-100%);
//   transition: all .5s;
// }
// .from-bottom2-enter,
// .from-bottom2-leave-to {
//   transform: translateY(0);
//    transition: all .5s;
// }
.burger-fade-enter-active,
.burger-fade-leave-active {
  transition: opacity 0.5s;
}
.burger-fade-enter,
.burger-fade-leave-to {
  opacity: 0;
}
</style>

